import React from 'react';
import styles from './Field.module.css';

export default function Field({ children, label, className = '', ...rest }) {
  return (
    <div className={`${styles.field} ${className}`} {...rest}>
      {label && <label className={styles.label}>{label}</label>}
      {children}
    </div>
  );
}
